module.exports = __webpack_public_path__ + "a6fe1fd242f601fb1401917a6aff2b29.svg";